import React from 'react'
import PalletBuilderSuperStore from "../stores/PalletBuilderSuperStore";
import StationAdoptStore from "../stationadopt/StationAdoptStore";
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import FormHelperText from "@material-ui/core/FormHelperText";
import {Controller} from "react-hook-form";
import LinearProgress from '@material-ui/core/LinearProgress';

const StationChooserForSite = (props) => {

    const [choices, setChoices] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [defaultValue, setDefaultValue] = React.useState();
    React.useEffect(() => {


            async function anyNameFunction() {
                const adopted = await new StationAdoptStore().read();
                if (!adopted) {
                    setChoices([{id: 'StationNotAssigned', name: 'Error: Station not assigned'}]);
                    return;
                }
                else {
                    setDefaultValue(adopted.data.stationId);
                }
                const stations = await new PalletBuilderSuperStore().getStationsOnThisSite();
                const choices = [];
                stations.data.forEach(station => {
                    choices.push({id: station.id, name: station.name});
                });
                setChoices(choices);
                setLoading(false);
            };

            anyNameFunction();

        }
        , []);

    const items = [];
    choices.forEach(choice => items.push(<MenuItem value={choice.id} key={choice.id}>{choice.name}</MenuItem>))

    const name = props.name ? props.name : "stationId";

    if (loading)
        return (<LinearProgress />)

    return (

        <FormControl
            error={Boolean(props.errors[name])}
            size={"small"}
            fullWidth
        >


            <InputLabel id={name}  {...props}>
                {props.label}
            </InputLabel>
            <Controller
                control={props.control}
                as={
                    <Select
                        {...props}
                        inputRef={props.register}
                    >
                        {items}
                    </Select>



                }
                name={name}
                defaultValue={props.defaultValue ? props.defaultValue : defaultValue}
            />
            <FormHelperText>
                {props.errors[name] && props.errors[name].message}
            </FormHelperText>
        </FormControl>


    );

}

export default StationChooserForSite;
